<template>
	<div>
		<div v-for="row in keys" :key="row" class="abcGameKeyboard">
			<button
				v-for="key in row"
				:key="key"
				class="buttonKeyboard"
				:class="{ 'button-keyboard-disabled': usedLetters.includes(key) }"
				@click="click(key, $event)"
				:disabled="usedLetters.includes(key)"
			>
				{{ key }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'keyboard',
	data() {
		return {
			keys: ['abcdefghijklmno', 'pqrstuvwxzyäöüß'],
		};
	},
	props: {
		usedLetters: String,
	},
	methods: {
		click(key, e) {
			this.$emit('key', key);
			e.target.blur();
		},
	},
};
</script>
